import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { PageContainer } from '../../../components/PageContainer';
import { EsimUpdateThankYouNotice } from '../../dashboard/components/EsimUpdateNotice';

export const ThankYou = () => {
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get('order') || '';
  const productName = searchParams.get('product') || '';
  const [esimManualUpdate, setEsimManualUpdate] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    // Check if this SIM needs the eSIM manual update (email already sent at step 5)
    const flag = localStorage.getItem('esim_manual_update');
    if (flag) {
      setEsimManualUpdate(flag);
      localStorage.removeItem('esim_manual_update');
    }
  }, []);

  return (
    <PageContainer title="">
      <Container>
        <SuccessIcon>✓</SuccessIcon>
        <ThankYouTitle>Thank You!</ThankYouTitle>

        <OrderInfoCard>
          <OrderInfoText>
            {orderNumber && (
              <p>
                Order Number: <strong>{orderNumber}</strong>
              </p>
            )}
            {productName && (
              <p>
                Product: <strong>{productName}</strong>
              </p>
            )}
            <p>Your Farmstream Multi-network Streaming plan has been activated</p>
          </OrderInfoText>
        </OrderInfoCard>

        <SupportInfo>
          <h3>What happens next?</h3>
          <p>
            Your camera should come online in the next few hours. If it still doesn't come online,
            we recommend powering it off and on to reconnect the camera to the available networks
            now that your 4G plan is active.
          </p>
          <p>
            If you have any questions, please contact us at{' '}
            <Link href="mailto:support@farmstream.co.uk">support@farmstream.co.uk</Link>.
          </p>
        </SupportInfo>

        {esimManualUpdate && <EsimUpdateThankYouNotice batchLabel={esimManualUpdate} />}

        <ButtonsContainer>
          <StyledButton primary href="/">
            Go to Dashboard
          </StyledButton>
          <StyledButton href="/activate">Activate Another Streaming Plan</StyledButton>
          <StyledButton href="https://www.farmstream.co.uk/pages/setup-1" target="_blank" rel="noopener noreferrer">
            Camera Setup Instructions
          </StyledButton>
        </ButtonsContainer>
      </Container>
    </PageContainer>
  );
};

const Container = styled.div`
  padding: 0 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin-top: 2rem;
`;

const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  margin-bottom: 1rem;
`;

const ThankYouTitle = styled.h1`
  margin: 0;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.large};
`;

const OrderInfoCard = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.gray};
`;

const OrderInfoText = styled.div`
  text-align: center;

  p {
    margin: 0.5rem 0;
    font-size: ${({ theme }) => theme.fontSize.small};
  }
`;

const SupportInfo = styled.div`
  width: 100%;
  max-width: 600px;
  text-align: center;

  h3 {
    margin-bottom: 1rem;
    font-size: ${({ theme }) => theme.fontSize.medium};
  }

  p {
    margin: 0.5rem 0;
    font-size: ${({ theme }) => theme.fontSize.small};
  }
`;

const Link = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  @media (max-width: 850px) {
    flex-direction: column;
  }
`;

const StyledButton = styled.a<{ primary?: boolean }>`
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;

  background-color: ${({ theme, primary }) => (primary ? theme.colors.primary : 'white')};
  color: ${({ theme, primary }) => (primary ? 'white' : theme.colors.primary)};
  border: 1px solid ${({ theme }) => theme.colors.primary};

  &:hover {
    opacity: 0.9;
  }
`;
